import React from 'react';


export default function() {
    return <>
        <p>This post motivates the complete zeta function {String.raw`\(\zeta_{\mathbb{A}}(z) = \pi^{-z/2} \, \Gamma(z/2) \, \zeta(z)\)`}, explaining how it arises in a natural way by including contributions from all possible completions of {String.raw`\(\mathbb{Q}\)`}. The argument is from Andreas Knauf’s excellent <a href='https://empslocal.ex.ac.uk/people/staff/mrwatkin/zeta/knauf1.pdf'>lecture notes</a>; I just fill in some details.</p>
    </>;
}
